import { apiFetch } from '../api-client';

export type CashEntryType = 'receipt' | 'payment';
export type CashMethod = 'cash_1111' | 'bank_1121';

export interface CashEntry {
  id: string;
  code: string;
  entryType: CashEntryType;
  method: CashMethod;
  entryDate: string;
  description: string;
  offsetAccount: string;
  actor: string;
  amount: number;
  createdBy: string;
  createdAt: string;
}

export interface CashSummary {
  openingBalance: number;
  totalIn: number;
  totalOut: number;
  closingBalance: number;
  countIn: number;
  countOut: number;
}

export const cashEntriesApi = {
  list: (query: { method?: CashMethod; from?: string; to?: string } = {}) => {
    const p = new URLSearchParams();
    if (query.method) p.set('method', query.method);
    if (query.from) p.set('from', query.from);
    if (query.to) p.set('to', query.to);
    const q = p.toString() ? `?${p.toString()}` : '';
    return apiFetch<{ items: CashEntry[]; summary: CashSummary }>(`/api/cash-entries${q}`);
  },
  create: (input: Omit<CashEntry, 'id' | 'createdBy' | 'createdAt'>) =>
    apiFetch<CashEntry>('/api/cash-entries', { method: 'POST', body: JSON.stringify(input) }),
  remove: (id: string) => apiFetch<{ ok: true }>(`/api/cash-entries/${id}`, { method: 'DELETE' }),
};
